module.exports = __webpack_public_path__ + "img/card_home2.90894d1c.svg";